import React, { useState } from 'react';
import { Button, Input, Radio } from 'antd';
import { Col, Row } from 'react-bootstrap';
import { Label } from '../../views/contactanos/contactanos';

import './index.css'
import { checkIsNotEmpty } from '../../../helper/validations';
import { errorSwal } from '../../../helper/swalHelpers';

const Flota = ({ states }) => {
    const [form, setForm] = useState({
        tipoVehiculos: undefined,
        comentarios: undefined,
        equipamiento: undefined,
        cantidad: 1,
        tipo: 'flotas'
    });

    const handleChange = ({ target: { name, value } }) => {
        setForm({ ...form, [name]: value });
    }

    const handleChangeRestar = () => {
        if (cantidad >= 2) {
            let newCantidad = cantidad - 1;
            setForm({ ...form, cantidad: newCantidad });

        }

    }

    const handleChangeSumar = () => {
        if (cantidad < 10) {
            let newCantidad = cantidad + 1;
            setForm({ ...form, cantidad: newCantidad });
        }
    };

    const validarForm = () => {
        if (
            !checkIsNotEmpty(tipoVehiculos) ||
            !checkIsNotEmpty(comentarios) ||
            equipamiento === undefined
        ) return false;
        return true;
    }

    const handleContinue = () => {
        if (!validarForm()) {
            errorSwal("Ocurrió un error", "Recuerda ingresar todos los campos requeridos.", "Ok");
            return;
        }
        states.setProducto(form);
        states.setFormP(form);
        states.setPaso(1);

    }

    const { tipoVehiculos, comentarios, equipamiento, cantidad } = form;

    return (
        <>
            <LayoutForm>
                <p className="bold-title-hyundai f-responsive mb-3">Datos de la flota a cotizar</p>
                <Label texto="Tipo de vehículos" />
                <Input value={tipoVehiculos} onChange={handleChange} name="tipoVehiculos" className={`agenda-input`} maxLength={50} />
            </LayoutForm>
            <LayoutForm>
                <Label texto="Comentarios" />
                <Input.TextArea name="comentarios" onChange={handleChange} value={comentarios} className={`agenda-input`} maxLength={250} autoSize={{ minRows: 2, maxRows: 4 }} />
            </LayoutForm>
            <LayoutForm>
                <Label texto="Vehículos con equipamiento" />
                <Radio.Group onChange={handleChange} value={equipamiento} name="equipamiento" >
                    <Radio value={true}>Sí</Radio>
                    <Radio value={false}>No</Radio>
                </Radio.Group>
            </LayoutForm>
            <LayoutForm>
                <Label texto="Cantidad" />
                <button className="btn-unidad-ficha btn-restar" onClick={handleChangeRestar}>-</button>
                <Input className="input-unidad-hyundai" value={cantidad} readOnly />
                <button className="btn-unidad-ficha btn-sumar" onClick={handleChangeSumar}>+</button>
            </LayoutForm>
            <LayoutForm>
                <Button className="btn-primario font-btn w-100 f-responsive mb-5" onClick={handleContinue}>Siguiente</Button>
            </LayoutForm>
        </>
    );
}

export const LayoutForm = ({ children }) => (
    <Row>
        <Col xs={11} md={12} lg={11} xl={10} className="mx-auto mt-2 mb-md-3 mb-2">
            {children}
        </Col>
    </Row>
)

export default Flota;